import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest, Debounce } from '../../helpers';
import Message from '../Common/Message/Message';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './GetToken.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class GetToken extends Component {
	constructor(props) {
        super(props);
        this.state = {  
            ticket_id: -1,
            message: {
                title: '',
                content: '',
                type: ''
            },
        };
    }
    
    componentDidMount() {
        
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    handleChange = (e) => {
        let ticket_id = this.state.ticket_id;
        ticket_id = e.target.value;
        this.setState({
            ticket_id,
        });
    }

    submit = async () => {
        this.setMessage('', '', 'loading');
        let ticket_id = this.state.ticket_id;
        const getTokenResponse = await getToken(ticket_id);
        console.log('getTokenResponse:', getTokenResponse);
        if (!getTokenResponse.data.error) {
            this.setMessage('Token', getTokenResponse.data.token, 'success');
        } else {
            this.setMessage('Oooops', getTokenResponse.data.error.code, 'error');
        }

        async function getToken(ticket_id) {
            return await ApiRequest(`/dev/distribution-token?ticket_id=${ticket_id}`, {
                method: 'GET',
            });
        }
    }
	
    render() {
		return (
            <div className="showtix-section container">
                <div className="row">
                    <div className="col-12 text-center">
                        <Message
                            message={this.state.message}
                        />
                    </div> 
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="showtix-form__group">
                            <label className="showtix-label" htmlFor={`ticket_id`}>
                                Ticket ID
                            </label>
                            <div className="showtix-form__input">
                                <input
                                    id={`ticket_id`}
                                    className="showtix-input"
                                    type="text"
                                    name={`ticket_id`}
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state.ticket_id}
                                />
                            </div>
                        </div>
                        <button
                            className={`showtix-button showtix-background__primary-1`}
                            onClick={() => this.submit()}
                            disabled={this.state.message.type === 'loading'}
                        >
                            <span>Submit</span>
                        </button>
                    </div>
                </div>
            </div>
		);
  	}
}

export default GetToken;



// WEBPACK FOOTER //
// ./src/components/GetToken/GetToken.js